

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button, Box, Typography, TextField } from "@mui/material";
import {
    Upload, X, Sparkles, Smartphone, Globe, Store, Users,
    Briefcase, Building2, Truck, ShoppingCart, CreditCard,
    Search, Grid3x3, UserCircle, Phone, Mail, Calendar, Clock,
    Image as ImageIcon, Video, ChevronLeft, ChevronRight,
    Download, Eye, LayoutTemplate, Megaphone, AppWindow, Monitor, Share2, FileText, MessageCircle, ShoppingBag
} from 'lucide-react';
import './Createcampaign.css';
import './MediumMedia.css';
import { getScreens } from "../../../../Component/Servicefile/campaignService";


const MediumMedia = ({
    goal, subGoal, name,
    mediums, audience, mediaTypes, mediaDurations,
    mediaDescriptions, callToAction, images,
    aiGeneratedImages, videoFile,
    onInputChange,       // ← syncs back to parent
    onMultiSelect,
    onMediaDurationChange,
    onImageUpload,
    onVideoUpload,
    appTypes,
    placements,
    showAIPrompt, setShowAIPrompt,
    aiPromptText, setAiPromptText,
    isGenerating, onAIGenerate,
    goals, subGoals,
    screensData,
    setScreensData,
    websiteUrl,
    onNext, onBack,
    durationSeconds,
    goalConfig,
    handleGoalConfigChange,
}) => {
    const navigate = useNavigate();
    const safeMediums = mediums || [];
    const safePlacements = Array.isArray(placements) ? placements : [];
    const safeAudience = audience || [];
    const safeMediaTypes = mediaTypes || [];
    const [expandedLocation, setExpandedLocation] = useState(null);
    const durationOptions = [5, 10, 15, 20];
    const [openFormModal, setOpenFormModal] = useState(false);
    const [selectedFields, setSelectedFields] = useState([
        "Full name",
        "Phone number",
        "Email"
    ]);
    useEffect(() => {
        if (openFormModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [openFormModal]);

    // ── local formData rebuilt from props ──
    const formData = {
        goal: goal || '',
        subGoal: subGoal || '',
        name: name || '',
        mediums: mediums || [],
        appTypes: appTypes || [],
        audience: audience || [],
        appScreens: [],
        callToAction: callToAction || '',
        mediaTypes: mediaTypes || [],
        mediaDurations: mediaDurations || { text: '', image: '', video: '' },
        mediaDescriptions: mediaDescriptions || {},
        aiGeneratedImages: aiGeneratedImages || [],
        videoFile: videoFile || null,
        images: images || [],
        placements: placements || [],
        websiteUrl: websiteUrl,
        durationSeconds: durationSeconds || '',
        contactMobile: goalConfig?.leads?.contactMobile || '',
    };
    const safeFormData = {
        goal: goal || '',
        subGoal: subGoal || '',
        name: name || '',
        mediums: mediums || [],
        placements: placements || [],
        audience: audience || [],
        mediaTypes: mediaTypes || [],
        mediaDurations: mediaDurations || { text: '', image: '', video: '' },
        mediaDescriptions: mediaDescriptions || {},
        callToAction: callToAction || '',
        images: images || [],
        aiGeneratedImages: aiGeneratedImages || [],
        videoFile: videoFile || null,
    };
    // const durationOptions = {
    //     image: [5, 10, 15, 20, 25, 30],
    //     video: [15, 20, 25, 30, 45, 60],
    //     text: [3, 5, 7, 10]
    // };
    const isBrandingDigital =
        formData?.goal === "branding" &&
        formData?.mediums?.includes("digital");
    const selectedScreenResolutions = screensData
        .filter(screen => formData.placements?.includes(screen.id))
        .map(screen => screen.resolution)
        .filter(Boolean);

    const appPlacementResolutionMap = {
        place_banner: "1080x960",
        in_app_popup: "1080x1356",
        adds: "1850x1080",
        cart: "1600x800"
    };

    // ✅ App selected resolutions
    const selectedAppResolutions = (formData.placements || [])
        .map(p => appPlacementResolutionMap[p])
        .filter(Boolean);


    const finalResolutions = isBrandingDigital
        ? selectedScreenResolutions
        : selectedAppResolutions;

    const callToActionOptions = [
        { value: 'apply_now', label: 'Apply now', icon: UserCircle },
        { value: 'book_now', label: 'Book now', icon: Calendar },
        { value: 'contact_us', label: 'Contact us', icon: Phone },
        { value: 'shop_now', label: 'Shop now', icon: ShoppingCart },
        // { value: 'sign_up', label: 'Sign up', icon: UserCircle },
        { value: 'get_directions', label: 'Get directions', icon: Search },
        { value: 'watch_more', label: 'Watch more', icon: Eye },
        { value: 'send_message', label: 'Send Message', icon: Mail },
        { value: 'get_quote', label: 'Get quote', icon: CreditCard },
        { value: 'enquire_now', label: 'Enquire Now', icon: MessageCircle },
        { value: 'order_now', label: 'Order Now', icon: ShoppingBag, },
    ];

    const APP_TYPES = [
        { value: "FOOD_AND_BEVERAGES", label: "Food & Beverages" },
        { value: "CATERINGS_SERVICES", label: "Catering Services" }
    ];
    const getFilteredCTAOptions = () => {
        if (subGoal === "more_leads") {
            return callToActionOptions.filter(opt =>
                ["get_quote", "contact_us", "enquiry", "send_message"].includes(opt.value)
            );
        }

        if (subGoal === "whatsapp_messages") {
            return callToActionOptions.filter(opt =>
                ["send_message", "contact_us"].includes(opt.value)
            );
        }
        if (subGoal === "website_visitors") {
            return callToActionOptions.filter(opt =>
                ["apply_now", "book_now", "watch_more", "shop_now"].includes(opt.value)
            );
        }
        if (subGoal === "more_calls") {
            return callToActionOptions.filter(opt =>
                ["contact_us"].includes(opt.value)
            );
        }
        return callToActionOptions;
    };


    const mediumOptions = [
        { value: 'app', label: 'App', icon: Smartphone },
        { value: 'digital', label: 'Digital', icon: Globe },
        // { value: 'physical', label: 'Physical', icon: Store }
    ];
    const goalMediumMap = {
        leads: ['app'],
        branding: ['digital', 'physical'],

    };
    const audienceOptions = [
        { value: 'users', label: 'Users', icon: Users },
        { value: 'vendors', label: 'Vendors', icon: Briefcase },
        // { value: 'companies', label: 'Companies', icon: Building2 },
        { value: 'movers', label: 'Movers', icon: Truck }
    ];

    const mediaTypeOptions = [
        { value: 'image', label: 'Image', icon: ImageIcon },
        { value: 'video', label: 'Video', icon: Video }
    ];
    const groupedScreens = screensData.reduce((acc, screen) => {
        // Optional: filter ACTIVE only
        // if (screen.screenStatus !== "ACTIVE") return acc;

        if (!acc[screen.location]) {
            acc[screen.location] = [];
        }

        acc[screen.location].push({
            value: screen.id,              // unique ID for selection
            label: screen.name,
            id: screen.deviceId,
            resolution: screen.resolution,
            screenSize: screen.screenSize
        });

        return acc;
    }, {});

    const digitalPlacements = Object.keys(groupedScreens).map(location => ({
        location,
        screens: groupedScreens[location]
    }));
    const filteredMediumOptions = mediumOptions.filter(option => {
        if (formData.goal === "branding") {
            return option.value === "digital" || option.value === "app";
        }

        if (formData.goal === "discount") {
            return option.value === "app"; // ✅ only app (example)
        }

        if (formData.goal === "leads") {
            return option.value === "app"; // or adjust if needed
        }

        return true;
    });
    const isValidResolution = (file, allowedRatios) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;

                const ratio = (width / height).toFixed(2);

                const valid = allowedRatios.some(r => {
                    const [w, h] = r.split(":").map(Number);
                    return (w / h).toFixed(2) === ratio;
                });

                resolve(valid);
            };
            img.src = URL.createObjectURL(file);
        });
    };
    const resolutionMap = {
        place_banner: "5:4 (e.g. 1000 × 800 px)",
        cart: "5:4 (e.g. 1000 × 800 px)",
        adds: "9:16 (e.g. 1080 × 1920 px)",
        in_app_popup: "9:16 (e.g. 1080 × 1920 px)",
    };
    const selectedResolutions = Array.isArray(safePlacements)
        ? safePlacements.map((p) => resolutionMap[p]).filter(Boolean)
        : [];

    useEffect(() => {
        const fetchScreens = async () => {
            try {
                const data = await getScreens();
                setScreensData(data);
            } catch (err) {
                console.error("❌ Error fetching screens:", err);
            }
        };

        fetchScreens();
    }, []);
    // Placement options per medium
    const placementsByMedium = {
        app: [
            { value: 'place_banner', label: 'Place Banner', icon: LayoutTemplate },
            { value: 'adds', label: 'Deals', icon: Megaphone },
            { value: 'cart', label: 'Cart', icon: ShoppingCart },
            { value: 'in_app_popup', label: 'In App Pop Up', icon: AppWindow },
        ],

        physical: [
            { value: 'store_banner', label: 'Store Banner', icon: Store },
            { value: 'flyer', label: 'Flyer', icon: FileText },
        ],
    };


    return (
        <>
            {/* ── Left Column — Form only, no outer wrapper ── */}
            <div className="premium-card">
                <div className="premium-card__content">
                    <div className="premium-step-content">

                        {/* Medium */}
                        {/* Medium Buttons */}
                        <div className="premium-form-group">
                            <label className="premium-form-label">Medium</label>
                            <div className="premium-button-group">
                                {filteredMediumOptions.map(option => {
                                    const Icon = option.icon;
                                    return (
                                        <button
                                            key={option.value}
                                            type="button"
                                            className={`premium-option-btn ${formData.mediums.includes(option.value) ? 'premium-option-btn--active' : ''}`}
                                            onClick={() => onMultiSelect('mediums', option.value)}
                                            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                        >
                                            <Icon size={16} />
                                            {option.label}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                        {safeMediums.map(medium => {
                            const placementsListRaw =
                                medium === "digital"
                                    ? digitalPlacements
                                    : placementsByMedium?.[medium] || [];

                            const placementsList =
                                formData?.goal === "leads" && medium === "app"
                                    ? placementsListRaw.filter(item => item.value === "adds")
                                    : placementsListRaw;
                            if (!placementsList.length) return null;

                            const mediumLabel = mediumOptions.find(m => m.value === medium)?.label;

                            return (
                                <div key={medium} className="premium-form-group" style={{ marginTop: '12px' }}>
                                    <label className="premium-form-label">
                                        {mediumLabel} Placements
                                    </label>

                                    {/* ✅ SHOW SCREENS ONLY FOR DIGITAL */}
                                    {medium === "digital" ? (
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

                                            {placementsList.map((loc, index) => {
                                                const isOpen = expandedLocation === index;

                                                return (
                                                    <div key={index}>

                                                        {/* 🔹 LOCATION HEADER */}
                                                        <div
                                                            onClick={() => setExpandedLocation(isOpen ? null : index)}
                                                            style={{
                                                                padding: "12px",
                                                                border: "1px solid #e5e7eb",
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                background: "#f9fafb",
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            📍 {loc.location}
                                                        </div>

                                                        {/* 🔹 EXPAND SCREENS */}
                                                        {isOpen && (
                                                            <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "8px" }}>

                                                                {loc.screens.map(screen => {
                                                                    const isSelected =
                                                                        Array.isArray(safePlacements) &&
                                                                        safePlacements.includes(screen.value);

                                                                    return (
                                                                        <div
                                                                            key={screen.value}
                                                                            onClick={() => onMultiSelect("placements", screen.value)}
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                gap: "10px",
                                                                                padding: "10px",
                                                                                border: "1px solid #e5e7eb",
                                                                                borderRadius: "6px",
                                                                                background: isSelected ? "#f0f9ff" : "#fff",
                                                                                cursor: "pointer",
                                                                                marginLeft: "10px"
                                                                            }}
                                                                        >
                                                                            <input type="checkbox" checked={isSelected} readOnly />

                                                                            <div>
                                                                                <div style={{ fontWeight: 500 }}>{screen.label}</div>
                                                                                <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                                                                    ID: {screen.id} 🖥 Resolution: {screen.resolution} ScreenSize: {screen.screenSize}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}

                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    ) : (
                                        /* ✅ KEEP YOUR ORIGINAL BUTTON CODE */
                                        <div className="premium-button-group">
                                            {placementsList.map(option => {
                                                const Icon = option.icon;

                                                const isSelected =
                                                    Array.isArray(safePlacements) &&
                                                    safePlacements.includes(option.value);

                                                return (
                                                    <button
                                                        key={option.value}
                                                        type="button"
                                                        className={`premium-option-btn ${isSelected ? 'premium-option-btn--active' : ''}`}
                                                        onClick={() => onMultiSelect('placements', option.value)}
                                                        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                                    >
                                                        <Icon size={16} />
                                                        {option.label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            );
                        })}


                        {formData.mediums?.includes("digital") && (
                            <div className="premium-form-group" style={{ marginTop: "12px" }}>
                                <label className="premium-form-label">Ad Duration</label>

                                <div className="premium-button-group">
                                    {[5, 10, 15, 20].map(sec => {
                                        const isSelected = formData.durationSeconds === sec;

                                        return (
                                            <button
                                                key={sec}
                                                type="button"
                                                className={`premium-option-btn ${isSelected ? 'premium-option-btn--active' : ''}`}
                                                onClick={() => onMultiSelect("durationSeconds", sec)}
                                            >
                                                {sec} sec
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                        {/* Business Vertical - Hide only when Digital is selected */}
                        {!formData.mediums.includes('digital') && (
                            <div className="premium-form-group">
                                <label className="premium-form-label">Business Vertical</label>

                                <div className="premium-button-group">
                                    {APP_TYPES.map(option => (
                                        <button
                                            key={option.value}
                                            type="button"
                                            className={`premium-option-btn ${formData.appTypes.includes(option.value)
                                                ? 'premium-option-btn--active'
                                                : ''
                                                }`}
                                            onClick={() => onMultiSelect('appTypes', option.value)}
                                        >
                                            {option.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                        {/* Placement Options — shown per selected medium */}


                        {/* App Audience */}
                        {formData.mediums.includes('app') && (
                            <div className="premium-form-group">
                                <label className="premium-form-label">App Audience</label>
                                <div className="premium-button-group">
                                    {audienceOptions.map(option => {
                                        const Icon = option.icon;
                                        return (
                                            <button
                                                key={option.value}
                                                type="button"
                                                className={`premium-option-btn ${formData.audience.includes(option.value) ? 'premium-option-btn--primary-active' : ''}`}
                                                onClick={() => onMultiSelect('audience', option.value)}
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                            >
                                                <Icon size={16} />{option.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Media Type */}
                        <div className="premium-form-group">
                            <label className="premium-form-label">Media Type</label>
                            <div className="premium-button-group">
                                {mediaTypeOptions.map(option => {
                                    const Icon = option.icon;
                                    return (
                                        <button
                                            key={option.value}
                                            type="button"
                                            className={`premium-option-btn ${formData.mediaTypes.includes(option.value) ? 'premium-option-btn--active' : ''}`}
                                            onClick={() => onMultiSelect('mediaTypes', option.value)}
                                            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                        >
                                            <Icon size={16} />{option.label}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>


                        {formData.mediaTypes.map((mediaType) => (
                            <div key={mediaType} className="premium-form-group">
                                <label className="premium-form-label">
                                    {mediaType.charAt(0).toUpperCase() + mediaType.slice(1)} Details
                                </label>

                                {/* Image Upload  <div> all the dta </div> code that is not controlled in the reginal postions of the */}
                                {mediaType === 'image' && (
                                    <div className="premium-upload-area">
                                        <div className="premium-upload-options">
                                            <div style={{ marginTop: "10px" }}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    multiple
                                                    onChange={onImageUpload}
                                                    style={{ display: "none" }}
                                                    id="image-upload"
                                                />

                                                <label
                                                    htmlFor="image-upload"
                                                    className="premium-upload-btn premium-upload-btn-primary"
                                                >
                                                    Choose Images
                                                </label>

                                                {/* ✅ SHOW RESOLUTION */}
                                                <div style={{ marginTop: "8px" }}>
                                                    {finalResolutions.length > 0 && (
                                                        <p style={{ fontSize: "12px", color: "#666", marginTop: "8px" }}>
                                                            Required Image Resolution:
                                                            <span style={{ color: "#e66d33", fontWeight: 600 }}>
                                                                {" "}
                                                                {finalResolutions.join(" / ")}
                                                            </span>
                                                        </p>
                                                    )}
                                                </div>
                                            </div>

                                        </div>

                                        {formData.images.length > 0 && (
                                            <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 10, padding: "6px 10px", backgroundColor: "#f0fdf4", borderRadius: "8px", border: "0.5px solid #bbf7d0" }}>
                                                <ImageIcon size={13} color="#3B6D11" />
                                                <span style={{ fontSize: "12px", color: "#3B6D11", fontWeight: 500 }}>
                                                    {formData.images.length} image{formData.images.length > 1 ? 's' : ''} uploaded — visible in preview
                                                </span>
                                            </div>
                                        )}

                                        {showAIPrompt && (
                                            <div className="premium-ai-prompt-container">
                                                <div className="premium-ai-prompt-box">
                                                    <h4 className="premium-ai-prompt-title"><Sparkles size={18} />Generate Image with AI</h4>
                                                    <textarea className="premium-ai-prompt-input" placeholder="Describe the image you want to generate..." value={aiPromptText} onChange={(e) => setAiPromptText(e.target.value)} rows="3" autoFocus />
                                                    <div className="premium-ai-prompt-actions">
                                                        <button className="premium-ai-prompt-btn premium-ai-prompt-btn-cancel" onClick={() => { setShowAIPrompt(false); setAiPromptText(''); }}>Cancel</button>
                                                        <button className="premium-ai-prompt-btn premium-ai-prompt-btn-generate" onClick={onAIGenerate} disabled={isGenerating || !aiPromptText.trim()}>
                                                            {isGenerating ? <><span className="premium-spinner"></span>Generating...</> : <><Sparkles size={16} />Generate Image</>}
                                                        </button>
                                                    </div>
                                                    <div className="premium-ai-prompt-samples">
                                                        <p className="premium-ai-prompt-samples-title">Try these:</p>
                                                        <div className="premium-ai-prompt-sample-chips">
                                                            {['Product on white background', 'Lifestyle product shot', '3D rendered product', 'Food photography'].map((sample, i) => (
                                                                <button key={i} className="premium-ai-prompt-sample-chip" onClick={() => setAiPromptText(sample)}>{sample}</button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Video Upload */}
                                {mediaType === 'video' && (
                                    <div
                                        className="premium-upload-area"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center"
                                        }}
                                    >
                                        <input
                                            type="file"
                                            accept="video/*"
                                            onChange={onVideoUpload}
                                            style={{ display: 'none' }}
                                            id="video-upload"
                                        />

                                        <label
                                            htmlFor="video-upload"
                                            className="premium-upload-btn premium-upload-btn-primary"
                                        >
                                            <Upload size={20} /> Choose Video
                                        </label>

                                        {/* ✅ ADD THIS (resolution display) */}
                                        {finalResolutions.length > 0 && (
                                            <p style={{ fontSize: "12px", color: "#666", marginTop: "8px" }}>
                                                Required Video Resolution:
                                                <span style={{ color: "#e66d33", fontWeight: 600 }}>
                                                    {" "}
                                                    {finalResolutions.join(" / ")}
                                                </span>
                                            </p>
                                        )}

                                        {formData.videoFile && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 6,
                                                    marginTop: 10,
                                                    padding: "6px 10px",
                                                    backgroundColor: "#f0fdf4",
                                                    borderRadius: "8px",
                                                    border: "0.5px solid #bbf7d0"
                                                }}
                                            >
                                                <Video size={13} color="#3B6D11" />
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#3B6D11",
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    Video uploaded — visible in preview
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Description */}
                                {mediaTypeOptions.map(option => {
                                    if (!formData.mediaTypes.includes(option.value)) return null;
                                    const Icon = option.icon;
                                    return (
                                        <Box key={option.value} sx={{ mt: 2, mb: 2, p: 2, border: "1.5px solid #e5e7eb", borderRadius: "10px", backgroundColor: "#f8fafc" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                                                <Box sx={{ width: 28, height: 28, borderRadius: "6px", backgroundColor: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <Icon size={14} color="#185FA5" />
                                                </Box>
                                                <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#374151" }}>{option.label} Description</Typography>
                                            </Box>
                                            <TextField
                                                fullWidth multiline rows={3} size="small"
                                                placeholder={option.value === "image" ? "Describe your image content, theme, or message..." : "Describe your video content, story, or key message..."}
                                                value={formData.mediaDescriptions?.[option.value] || ""}
                                                onChange={(e) => onInputChange("mediaDescriptions", { ...formData.mediaDescriptions, [option.value]: e.target.value })}
                                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff", fontSize: "13px", "&:hover fieldset": { borderColor: "#3b82f6" }, "&.Mui-focused fieldset": { borderColor: "#3b82f6" } } }}
                                            />
                                            <Typography sx={{ fontSize: "11px", color: "#9ca3af", mt: 0.5, textAlign: "right" }}>
                                                {(formData.mediaDescriptions?.[option.value] || "").length} / 300
                                            </Typography>
                                        </Box>
                                    );
                                })}



                                {formData.mediums?.includes("app") && formData.goal !== "discount" && (
                                    <div className="premium-form-group">
                                        <label className="premium-form-label">Call to Action</label>

                                        <div style={{ position: "relative", marginTop: 6 }}>
                                            <select
                                                value={formData.callToAction}
                                                onChange={(e) => onInputChange('callToAction', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    padding: "10px 36px 10px 14px",
                                                    fontSize: "13px",
                                                    color: formData.callToAction ? "#111827" : "#9ca3af",
                                                    backgroundColor: "#f8fafc",
                                                    border: "1.5px solid #e5e7eb",
                                                    borderRadius: "10px",
                                                    appearance: "none",
                                                    WebkitAppearance: "none",
                                                    cursor: "pointer",
                                                    outline: "none"
                                                }}
                                            >
                                                <option value="" disabled>Select call to action</option>

                                                {callToActionOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}

                                {/* ✅ SHOW CONTACT MOBILE FIELD */}
                                {["contact_us", "send_message"].includes(formData.callToAction) && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "16px"
                                        }}
                                    >
                                        <Box sx={{ width: "220px" }}>
                                            <Typography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: 600,
                                                    mb: "4px",
                                                    textAlign: "center"
                                                }}
                                            >
                                                Contact Mobile
                                            </Typography>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                placeholder="Enter mobile"
                                                value={goalConfig?.leads?.contactMobile || ""}
                                                onChange={(e) =>
                                                    handleGoalConfigChange("leads", "contactMobile", e.target.value)
                                                }
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "10px",
                                                        backgroundColor: "#f8fafc",
                                                        fontSize: "13px",
                                                    },
                                                    "& input::placeholder": {
                                                        color: "#9ca3af",
                                                        opacity: 1,
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </div>
                                )}

                                {/* ✅ SHOW CREATE FORM BUTTON */}
                                {/* {["get_quote", "enquire_now"].includes(formData.callToAction) && (
                                    <div
                                        style={{
                                            marginTop: "20px",
                                            display: "flex",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <button
                                            onClick={() => setOpenFormModal(true)}
                                            style={{
                                                padding: "12px 22px",
                                                background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "10px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
                                                transition: "all 0.25s ease"
                                            }}
                                            onMouseOver={e => {
                                                e.currentTarget.style.transform = "translateY(-2px)";
                                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(37, 99, 235, 0.4)";
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(37, 99, 235, 0.3)";
                                            }}
                                        >
                                            ➕ Create Form
                                        </button>
                                    </div>
                                )} */}

                                {["get_directions"].includes(formData.callToAction) && (
                                    <Box
                                        sx={{
                                            mt: 2,
                                            mb: 2,
                                            p: 2,
                                            border: "1.5px solid #e5e7eb",
                                            borderRadius: "10px",
                                            backgroundColor: "#f8fafc"
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                color: "#374151",
                                                mb: 1
                                            }}
                                        >
                                            Website URL
                                        </Typography>

                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Enter your website URL (https://example.com)"
                                            value={websiteUrl || ""}
                                            onChange={(e) =>
                                                onInputChange("websiteUrl", e.target.value)
                                            }
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    fontSize: "13px",
                                                    "&:hover fieldset": { borderColor: "#3b82f6" },
                                                    "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                                }
                                            }}
                                        />
                                    </Box>
                                )}
                            </div>
                        ))}




                        <div
                            style={{
                                width: "100%",
                                marginTop: "24px",
                                paddingTop: "18px",
                                display: "flex",
                                justifyContent: "center", // ✅ center everything
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    gap: "45px",          // ✅ space between buttons
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    startIcon={<ArrowBackIcon />}
                                    onClick={onBack}
                                    style={{
                                        minWidth: "100px",
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        padding: "7px"
                                    }}
                                >
                                    Back
                                </Button>

                                <Button
                                    variant="contained"
                                    endIcon={<ArrowForwardIcon />}
                                    onClick={onNext}
                                    sx={{
                                        borderRadius: "10px",
                                        fontWeight: 600,
                                        minWidth: "120px",
                                        textTransform: "none",
                                        padding: "7px"
                                    }}
                                >
                                    Next
                                </Button>

                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Nav buttons */}
            <>


                {/* ✅ MOVE MODAL HERE (OUTSIDE) */}
                {openFormModal && (
                    <div style={overlayStyle} onClick={() => setOpenFormModal(false)}>
                        <div
                            style={modalStyle}
                            onClick={(e) => e.stopPropagation()}
                        >

                            {/* HEADER */}
                            <div style={{
                                ...headerStyle,
                                fontSize: "16px",
                                fontWeight: 600
                            }}>
                                <span>Create Form</span>
                                <span
                                    style={{
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        color: "#6b7280"
                                    }}
                                    onClick={() => setOpenFormModal(false)}
                                >
                                    ✕
                                </span>
                            </div>

                            <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>

                                {/* LEFT PANEL */}
                                <div style={{ ...leftPanel, backgroundColor: "#fff" }}>

                                    <label style={{ fontSize: "13px", fontWeight: 600 }}>
                                        Form name <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <input
                                        type="text"
                                        placeholder="Enter form name"
                                        style={{
                                            ...inputStyle,
                                            marginTop: "6px",
                                            marginBottom: "14px"
                                        }}
                                    />

                                    <h4 style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        fontSize: "14px",
                                        color: "#111827"
                                    }}>
                                        Contact info
                                    </h4>

                                    {[
                                        "Full name",
                                        "Phone number",
                                        "Email",
                                        "Street address",
                                        "Date of birth",
                                        "Gender",
                                        "Job title",
                                        "Company name"
                                    ].map((item) => {
                                        const isChecked = selectedFields.includes(item);

                                        return (
                                            <div
                                                key={item}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    padding: "8px",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    backgroundColor: isChecked ? "#f0f9ff" : "transparent"
                                                }}
                                                onClick={() => {
                                                    if (isChecked) {
                                                        setSelectedFields(selectedFields.filter(f => f !== item));
                                                    } else {
                                                        setSelectedFields([...selectedFields, item]);
                                                    }
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    readOnly
                                                    style={{
                                                        accentColor: "#2563eb",
                                                        width: 16,
                                                        height: 16
                                                    }}
                                                />
                                                <span style={{ fontSize: "14px", color: "#374151" }}>
                                                    {item}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* RIGHT PANEL */}
                                <div style={{ ...rightPanel, backgroundColor: "#f9fafb" }}>

                                    <div>
                                        <p style={{
                                            fontSize: "12px",
                                            color: "#6b7280",
                                            marginBottom: "10px",
                                            fontWeight: 600
                                        }}>
                                            Live Preview
                                        </p>

                                        <div style={{ ...previewCard, padding: "18px" }}>
                                            <h4 style={{
                                                fontSize: "14px",
                                                marginBottom: "12px",
                                                color: "#111827"
                                            }}>
                                                Contact information
                                            </h4>

                                            {/* ✅ DYNAMIC FIELDS */}
                                            {selectedFields.map((field, index) => (
                                                <input
                                                    key={index}
                                                    placeholder={field}
                                                    style={previewInput}
                                                />
                                            ))}
                                        </div>
                                    </div>

                                    <button
                                        style={{
                                            ...nextBtn,
                                            marginTop: "20px",
                                            background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
                                            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)"
                                        }}
                                        onClick={() => setOpenFormModal(false)}
                                    >
                                        Save Form
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        </>

    );
};
const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const modalStyle = {
    width: "780px",
    maxWidth: "90vw",
    height: "560px",
    maxHeight: "90vh",
    backgroundColor: "#fff",
    borderRadius: "14px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
};

const headerStyle = {
    padding: "12px 16px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "600",
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: 10
};

const leftPanel = {
    width: "50%",
    padding: "16px",
    borderRight: "1px solid #e5e7eb",
    overflowY: "auto"
};

const rightPanel = {
    width: "50%",
    padding: "16px",
    // backgroundColor: "#f3f4f6",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflowY: "auto"
};
const inputStyle = {
    width: "100%",
    padding: "8px",
    marginTop: "5px",
    borderRadius: "6px",
    border: "1px solid #d1d5db"
};

const previewCard = {
    backgroundColor: "#fff",
    padding: "16px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
};

const previewInput = {
    width: "100%",
    padding: "8px",
    marginTop: "10px",
    border: "1px solid #e5e7eb",
    borderRadius: "6px"
};

const nextBtn = {
    marginTop: "20px",
    padding: "10px",
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer"
};

export default MediumMedia;